export default "__VITE_PUBLIC_ASSET__cbbac525__"